import { createContext } from '@synoptic/ui-kit/utils/create-context.js';
interface SidebarContext {
  isCollapsed: boolean;
  isCollapseForced: boolean;
  setIsCollapsed: (value: boolean | ((prev: boolean) => boolean)) => void;
}

export const [SidebarContextProvider, useSidebarContext] =
  createContext<SidebarContext>('SidebarContext');
